import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import './login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      const usersRef = collection(db, 'users');
      const q = query(
        usersRef, 
        where('username', '==', username),
        where('password', '==', password)
      );
      
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        setError('Invalid username or password');
        return;
      }

      navigate('/dashboard/block-management');
    } catch (err) {
      setError('Error during login: ' + err.message);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-content">
          <img src="/Block Logo-01.png" alt="Block Logo" className="block-logo" />
          <h1 className="login-title">Login</h1>
          {error && <p className="login-error">{error}</p>}
          <form onSubmit={handleLogin} className="login-form">
            <div className="form-group">
              <input
                type="text"
                className="form-input"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                className="form-input"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="login-button">
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;